import { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { INIT_ADMINS } from "./data/initialData";
import RoleSelector from "./pages/auth/RoleSelector";
import SuperAdminLogin from "./pages/auth/SuperAdminLogin";
import AdminLogin from "./pages/auth/AdminLogin";
import SuperAdminApp from "./pages/superadmin/SuperAdminApp";
import AdminApp from "./pages/admin/AdminApp";

function AppContent() {
  const [screen, setScreen] = useState("select");
  const [admins, setAdmins] = useState(INIT_ADMINS);
  const { user, logout } = useAuth();

  const handleLogout = () => { logout(); setScreen("select"); };

  if (screen === "select")
    return <RoleSelector onSelect={setScreen} />;

  if (screen === "superadmin")
    return <SuperAdminLogin
      onLogin={() => setScreen("superadmin-app")}
      goBack={() => setScreen("select")} />;

  if (screen === "admin")
    return <AdminLogin
      onLogin={() => setScreen("admin-app")}
      admins={admins}
      goBack={() => setScreen("select")} />;

  if (screen === "superadmin-app")
    return <SuperAdminApp admins={admins} setAdmins={setAdmins} onLogout={handleLogout} />;

  if (screen === "admin-app")
    return <AdminApp adminUser={user} onLogout={handleLogout} />;

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
